import React from "react";
import { Badge, makeStyles, tokens } from "@fluentui/react-components";
import { ITicket } from "../../interfaces/ITicket";

const useStyles = makeStyles({
  badge: {
    minWidth: "85px",
    padding: `0 ${tokens.spacingHorizontalL}`,
  },
});

export const TicketBadge = ({ ticket }: { ticket: ITicket }) => {
  const styles = useStyles();

  const getStatusColor = (
    status: string,
  ): "success" | "informative" | "brand" => {
    switch (status.toLowerCase()) {
      case "mottaget":
        return "informative";
      case "påbörjat":
        return "brand";
      case "slutfört":
        return "success";
      default:
        return "brand";
    }
  };

  return (
    <Badge
      size="large"
      appearance="tint"
      className={styles.badge}
      color={getStatusColor(ticket.status)}
    >
      {ticket.status}
    </Badge>
  );
};
